import React from "react";
import { SideMenuSettings } from "./SideMenuSettings";
import { SideMenuProfile } from "./SideMenuProfile";
import { SideMenuFaq } from "./SideMenuFaq";
import { SideMenuPrivacy } from "./SideMenuPrivacy";
import { SideMenuHelp } from "./SideMenuHelp";
import { SideMenuLanguage } from "./SideMenuLanguage";
import { SideMenuQuickstart } from "./SideMenuQuickstart";
import { SideMenuAdministrator } from "./administrator/SideMenuAdministrator";
import { CloseButton } from "../../../../components/styled/BasicBlocks";
import "./SideMenuRouter.css";


interface ISideMenuRouterProps {
    onSelect: (name: string) => void;
    selected: string;
}

export const SideMenuRouter = ({selected, onSelect} : ISideMenuRouterProps)=>{
    const views = {
        settings: SideMenuSettings,
        profile: SideMenuProfile,
        faq: SideMenuFaq,
        privacy: SideMenuPrivacy,
        language: SideMenuLanguage,
        quickstart: SideMenuQuickstart,
        help: SideMenuHelp,
        administrator: SideMenuAdministrator
    }

    const SelectedViewComponent = views[selected as keyof typeof views];

    return <div className="SideMenuRouter">
        {/*<CloseButton onClick={()=>{
            onSelect('');
        }}></CloseButton>*/}
        {SelectedViewComponent && <SelectedViewComponent onClose={()=>{onSelect('')}}></SelectedViewComponent>}
    </div>
}